import React from 'react';

import { Caption, Body1 } from '../FontStyles';
import { VictoryBar, VictoryContainer, VictoryStack } from 'victory';
import { Flex } from 'rebass';
import Styled from 'styled-components';
import baseTheme from '../../themes/baseTheme';

const StatsBoxCont = Styled(Flex)`
border: ${baseTheme.border};
border-radius: 8px;
padding: ${baseTheme.space[3]}px;

max-height: 350px;
${Flex} .VictoryContainer {




}
`;

class StatsBox extends React.Component {
  constructor() {
    super();
    this.state = {};
  }
  render() {
    let { data, avgBg, currentRangeStart, currentRangeEnd } = this.props;
    let realData = this.props.otherData;
    if (currentRangeEnd.toISOString) {
      realData = this.props.otherData.filter(x => {
        return x.time < currentRangeEnd.toISOString() && x.time > currentRangeStart.toISOString();
      });
    }
    const insulinEvents = realData.filter(x => x.rate || x.rate === 0 || x.normal);

    const bolusEvents = realData.filter(x => x.normal);
    const basalEvents = realData.filter(x => x.rate || x.rate === 0);
    const withoutSuppressed = basalEvents.filter(x => !x.suppressed);

    const insulinDateArray = insulinEvents.map(x => {
      if (x.normal) {
        return {
          date: x.date,
          dateFormatted: x.date.toLocaleString(),
          bolusAmount: x.normal,
          basalRateChange: 0,
          duration: x.duration
        };
      } else {
        return {
          date: x.date,
          dateFormatted: x.date.toLocaleString(),
          bolusAmount: 0,
          basalRateChange: x.rate,
          duration: x.duration / 60000,
          shouldEnd: x.duration,
          amountDelivered: ((x.duration / 60000) * x.rate) / 60
        };
      }
    });

    const totalBasalRateAtTarget = basalEvents.reduce(
      (total, x) =>
        total + (x.suppressed ? (x.suppressed.rate * x.duration) / (60 * 60000) : (1.0 * x.duration) / (60 * 60000)),
      0
    );

    const tempBasalAMounts = insulinDateArray.reduce((total, event) => {
      return total + (event.amountDelivered ? event.amountDelivered : 0);
    }, 0);

    const totalBasal = tempBasalAMounts;

    const totalBolusDelivered = insulinDateArray.reduce((total, event) => {
      return total + (event.bolusAmount > 0 ? event.bolusAmount : 0);
    }, 0);

    const totalInsulinDelivered = totalBasal + totalBolusDelivered;

    return (
      <div>
        <StatsBoxCont mt={3} flexWrap="wrap">
          <Flex justifyContent="space-between" flexWrap="wrap">
            <Flex width={1} flexWrap="wrap">
              <Flex mb="-8px" width={1}>
                <Body1> Current time period: </Body1>
              </Flex>
              <Caption style={{ fontSize: '10px' }}>
                {currentRangeStart.toLocaleString()} - {currentRangeEnd.toLocaleString()}
              </Caption>
            </Flex>
          </Flex>
        </StatsBoxCont>
        <StatsBoxCont mt={3} flexWrap="wrap">
          <Flex justifyContent="space-between" flexWrap="wrap">
            <Flex mb="-8px" width={1}>
              <Body1> Time in Range </Body1>
            </Flex>
          </Flex>
          <Flex width={1}>
            <VictoryBar
              horizontal
              containerComponent={<VictoryContainer style={{ maxHeight: '300px' }} />}
              domainPadding={0}
              barRatio={1.2}
              domain={{ y: [-1, 100] }}
              padding={{ top: 20, bottom: 60, left: 0, right: 40 }}
              data={data}
              style={{ data: { fill: datum => datum.fill } }}
              x="name"
              y="percentOfSegment"
              labels={d => `${d.percentOfSegment}%`}
            />
          </Flex>
        </StatsBoxCont>
        <StatsBoxCont mt={3} flexWrap="wrap">
          <Flex justifyContent="space-between" flexWrap="wrap">
            <Flex flexWrap="wrap" width={1}>
              <Body1>Avg Blood Glucose: {avgBg} mg/dL </Body1>
            </Flex>
          </Flex>
        </StatsBoxCont>

        <StatsBoxCont mt={3} flexWrap="wrap">
          <Flex justifyContent="space-between" flexWrap="wrap">
            <Flex flexWrap="wrap" width={1}>
              <Body1>Total Insulin Delivered: {parseFloat(totalInsulinDelivered).toFixed(2)} U </Body1>
            </Flex>

            <Flex flexWrap="wrap" width={1}>
              <Body1>Total Bolus Delivered: {parseFloat(totalBolusDelivered).toFixed(2)} U </Body1>
            </Flex>
            <Flex flexWrap="wrap" width={1}>
              <Body1>Total Basal Delivered: {parseFloat(totalBasal).toFixed(2)} U </Body1>
            </Flex>
            <Flex flexWrap="wrap" width={1}>
              <Body1>Total Scheduled Basal: {parseFloat(totalBasalRateAtTarget).toFixed(2)} units </Body1>
            </Flex>
            <Flex flexWrap="wrap" width={1}>
              <Body1>
                Total Loop Activity:
                {(
                  ((parseFloat(totalBasal).toFixed(2) - parseFloat(totalBasalRateAtTarget).toFixed(2)) /
                    parseFloat(totalBolusDelivered).toFixed(2)) *
                  100
                ).toFixed(2) > 0
                  ? ' +'
                  : ' '}
                {(
                  ((parseFloat(totalBasal).toFixed(2) - parseFloat(totalBasalRateAtTarget).toFixed(2)) /
                    parseFloat(totalBasalRateAtTarget).toFixed(2)) *
                  100
                ).toFixed(2)}
                %
              </Body1>
            </Flex>
          </Flex>
        </StatsBoxCont>
        <StatsBoxCont mt={3} flexWrap="wrap">
          <VictoryStack
            horizontal
            containerComponent={<VictoryContainer style={{ maxHeight: '300px' }} />}
            domainPadding={0}
            barRatio={1.2}
            domain={{ y: [0, 100] }}
            padding={{ top: 20, bottom: 60, left: 0, right: 40 }}
            data={([{ x: 'day', y: 1 }], [{ x: 'day', y: 2 }])}
            style={{ data: { fill: datum => datum.fill } }}
            x="x"
            y="y"
            labels={d => `${d.percentOfSegment}%`}
          />
        </StatsBoxCont>
      </div>
    );
  }
}
export default StatsBox;
